// extracted by mini-css-extract-plugin
export default {"page":"cY","heading":"eY","subheading":"fY","flavorbox":"gY","inner":"hY","image":"iY","label":"jY","flavorselect":"kY","arrow":"lY","flavorswrap":"mY","flavorsheader":"nY","flavorsnav":"oY","flavorsinner":"pY","cancelbtn":"qY","flavorsbottom":"rY","retakebtn":"sY","continueBtn":"tY","drawerinner":"uY","videowrap":"vY","flavorsbottomnav":"wY"};
    if(module.hot) {
      // 1726593107672
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  